//src/pages/profile/purchasesTab.js
import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  fetchBalance,
  fetchPurchases,
  downloadInvoice,
} from "../../api/credits/creditsApi";
import assessment from "../../assets/images/apple-touch-icon.png";
import { TbFileDownload } from "react-icons/tb";

const PurchasesTab = () => {
  const [balance, setBalance] = useState(0);
  const [rows, setRows] = useState([]);
  const user_id = localStorage.getItem("user_id");

  const refreshData = useCallback(async () => {
    const [bal, pur] = await Promise.all([
      fetchBalance(user_id),
      fetchPurchases(user_id),
    ]);
    setBalance(bal.data.balance);
    setRows(pur.data);
  }, [user_id]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const qs = new URLSearchParams(location.search);
    if (qs.get("status") === "success") {
      toast.success(`Payment successful – ${qs.get("qty")} credits added!`);
    } else if (qs.get("status") === "failure") {
      toast.error("Payment failed or cancelled.");
    }
    if (qs.get("status")) navigate("/your_order_history", { replace: true });
  }, [location.search, navigate]);

  const handleDownload = async (id, invoiceNo) => {
    const res = await downloadInvoice(id, user_id);
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.download = `Invoice_${invoiceNo}.pdf`;
    link.click();
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-white via-indigo-50 to-purple-50 overflow-hidden">

   
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div>

     
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-30px); }
          100% { transform: translateY(0px); }
        }
        @keyframes float2 {
          0% { transform: translateY(0px); }
          50% { transform: translateY(30px); }
          100% { transform: translateY(0px); }
        }
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
        .animate-float2 {
          animation: float2 10s ease-in-out infinite;
        }
      `}</style>

   
      <div className="relative z-10 w-full lg:w-8/12 mx-auto px-2 sm:px-4 py-6">

  
        <div className="mb-6 text-center">
          <h2 className="text-base sm:text-xl font-semibold text-[#36369f] mb-2">
            Current Balance: {balance} credits
          </h2>

          <h3 className="text-xl sm:text-2xl font-bold text-[#36369f]">
            My Orders
          </h3>
        </div>

      
        <div className="overflow-x-auto rounded-xl border border-indigo-100 shadow-sm bg-white/70 backdrop-blur-md">

          <table className="min-w-full border-collapse">

        
            <thead className="bg-gradient-to-l from-indigo-950 to-indigo-800 text-white">
              <tr className="text-center text-xs sm:text-base">
                <th className="p-3 text-left hidden sm:table-cell"></th>
                <th className="p-3 text-left">INVOICE NO.</th>
                <th className="p-3 hidden md:table-cell">ORDERED AT</th>
                <th className="p-3">QUANTITY</th>
                <th className="p-3">TOTAL</th>
                <th className="p-3">STATUS</th>
                <th className="p-3">INVOICE</th>
              </tr>
            </thead>

         
            <tbody>
              {rows.map((p) => (
                <tr
                  key={p._id}
                  className="border-t hover:bg-indigo-50 transition text-center"
                >
                  <td className="p-3 hidden sm:table-cell">
                    <img
                      src={assessment}
                      alt="logo"
                      className="w-10 h-10 mx-auto rounded-md border border-indigo-100"
                    />
                  </td>

                  <td className="p-3 font-semibold text-sm text-gray-800 text-left">
                    #{p.invoiceNo}
                  </td>

                  <td className="p-3 hidden md:table-cell text-sm text-gray-600">
                    {new Date(p.createdAt).toLocaleDateString()}
                  </td>

                  <td className="p-3 text-sm font-medium">
                    {p.quantity}
                  </td>

                  <td className="p-3 text-sm font-semibold text-indigo-600">
                    ₹ {p.amount}
                  </td>

                  <td className="p-3 text-sm">
                    {p.status === "PAID" && (
                      <span className="px-2 py-1 rounded-full bg-green-100 text-green-700 text-xs font-semibold">
                        Paid
                      </span>
                    )}
                    {p.status === "PENDING" && (
                      <span className="px-2 py-1 rounded-full bg-yellow-100 text-yellow-700 text-xs font-semibold">
                        Pending
                      </span>
                    )}
                    {p.status === "FAILED" && (
                      <span className="px-2 py-1 rounded-full bg-red-100 text-red-700 text-xs font-semibold">
                        Failed
                      </span>
                    )}
                  </td>

                  <td className="p-3">
                    <button
                      onClick={() => handleDownload(p._id, p.invoiceNo)}
                      disabled={p.status !== "PAID"}
                      className={`flex items-center justify-center mx-auto p-2 rounded-md transition ${
                        p.status === "PAID"
                          ? "text-indigo-600 hover:bg-indigo-100 hover:scale-110"
                          : "text-gray-400 cursor-not-allowed"
                      }`}
                    >
                      <TbFileDownload size={18} />
                    </button>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>
    </div>
  );
};

export default PurchasesTab;